(function () {
  'use strict';

  /* @ngdoc object
   * @name transactions
   * @description
   *
   */
  angular
    .module('transactions', [
      'ui.router'
    ]);
}());
